import type { IFieldValidationParams } from '../validation.types';
import { ValidationErrorType } from '../validation.types';

const MIN_FIELD_USERNAME_LENGTH = 2;

export const usernameValidation = ({
  value,
  errorToText,
}: IFieldValidationParams): string | null => {
  if (!value) {
    return errorToText[ValidationErrorType.Empty] || '';
  }

  const trimmedUsername = value.trim();

  if (!trimmedUsername || trimmedUsername.length < MIN_FIELD_USERNAME_LENGTH) {
    return errorToText[ValidationErrorType.TooShort] || '';
  }

  return null;
};
